import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066d0058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ftl-order" }
const _hoisted_2 = { class: "ftl-order__container" }
const _hoisted_3 = { class: "container__slot" }
const _hoisted_4 = {
  key: 0,
  class: "FtlEditContainer"
}
const _hoisted_5 = { class: "FtlEditContainer__block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Основная информация", -1))
const _hoisted_7 = { class: "block__content" }
const _hoisted_8 = { class: "block__field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата забора", -1))
const _hoisted_10 = { class: "field__value" }
const _hoisted_11 = { class: "block__field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Время забора", -1))
const _hoisted_13 = { class: "field__value" }
const _hoisted_14 = { class: "block__field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер АВР Spark", -1))
const _hoisted_16 = { class: "field__value" }
const _hoisted_17 = { class: "block__field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата АВР", -1))
const _hoisted_19 = { class: "field__value" }
const _hoisted_20 = { class: "block__field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Отработанные часы для выставления ", -1))
const _hoisted_22 = { class: "field__value" }
const _hoisted_23 = { class: "block__field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Количество авто", -1))
const _hoisted_25 = { class: "field__value" }
const _hoisted_26 = { class: "block__field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер накладной заказчика", -1))
const _hoisted_28 = { class: "field__value" }
const _hoisted_29 = { class: "block__field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес отправителя", -1))
const _hoisted_31 = { class: "field__value" }
const _hoisted_32 = {
  key: 1,
  class: "FtlEditContainer"
}
const _hoisted_33 = { class: "FtlEditContainer__block" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Данные об оплате", -1))
const _hoisted_35 = { class: "block__content" }
const _hoisted_36 = { class: "block__field" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Объявленная стоимость", -1))
const _hoisted_38 = { class: "field__value" }
const _hoisted_39 = { class: "block__field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Кем будет производиться оплата ", -1))
const _hoisted_41 = { class: "field__value" }
const _hoisted_42 = { class: "block__field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Предоплата", -1))
const _hoisted_44 = { class: "field__value" }
const _hoisted_45 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_46 = { class: "block__field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип простоя", -1))
const _hoisted_48 = { class: "field__value" }
const _hoisted_49 = { class: "block__field" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Кол-во часов простоя для себестоимости ", -1))
const _hoisted_51 = { class: "field__value" }
const _hoisted_52 = { class: "block__field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Кол-во часов простоя для выставления ", -1))
const _hoisted_54 = { class: "field__value" }
const _hoisted_55 = { class: "block__field" }
const _hoisted_56 = { class: "field__placeholder" }
const _hoisted_57 = { class: "field__value" }
const _hoisted_58 = { class: "block__field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Выставление за простой", -1))
const _hoisted_60 = { class: "field__value" }
const _hoisted_61 = {
  key: 1,
  class: "flex items-center justify-end"
}
const _hoisted_62 = {
  key: 0,
  class: "FtlEditContainer__block"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "СЕБЕСТОИМОСТЬ", -1))
const _hoisted_64 = { class: "block__content" }
const _hoisted_65 = { class: "block__field" }
const _hoisted_66 = { class: "field__placeholder" }
const _hoisted_67 = { class: "field__value" }
const _hoisted_68 = { class: "block__field" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Общая себестоимость за перевозку ", -1))
const _hoisted_70 = { class: "field__value" }
const _hoisted_71 = {
  key: 1,
  class: "FtlEditContainer__block"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "ВЫСТАВЛЕНИЕ", -1))
const _hoisted_73 = { class: "block__content" }
const _hoisted_74 = { class: "block__field" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Выставление клиенту за перевозку за рейс ", -1))
const _hoisted_76 = { class: "field__value" }
const _hoisted_77 = { class: "block__field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Выставление клиенту за перевозку ", -1))
const _hoisted_79 = { class: "field__value" }
const _hoisted_80 = {
  key: 2,
  class: "FtlEditContainer"
}
const _hoisted_81 = { class: "FtlEditContainer__block" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "ИНФОРМАЦИЯ О МАШИНЕ", -1))
const _hoisted_83 = { class: "block__content" }
const _hoisted_84 = { class: "block__field" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Компания перевозчик", -1))
const _hoisted_86 = { class: "field__value" }
const _hoisted_87 = { class: "flex items-center" }
const _hoisted_88 = { class: "flex items-center" }
const _hoisted_89 = { class: "block__field" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Автомобиль", -1))
const _hoisted_91 = { class: "field__value" }
const _hoisted_92 = { class: "block__field" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Марка авто", -1))
const _hoisted_94 = { class: "field__value" }
const _hoisted_95 = { class: "block__field" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Кубатура", -1))
const _hoisted_97 = { class: "field__value" }
const _hoisted_98 = { class: "block__field" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип погрузки", -1))
const _hoisted_100 = { class: "field__value" }
const _hoisted_101 = { class: "block__field" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Температурный режим", -1))
const _hoisted_103 = { class: "field__value" }
const _hoisted_104 = { class: "block__field" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Гос. номер", -1))
const _hoisted_106 = { class: "field__value" }
const _hoisted_107 = { class: "block__field" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Водитель", -1))
const _hoisted_109 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_110 = { class: "block__field" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Грузоподъёмность", -1))
const _hoisted_112 = { class: "field__value" }
const _hoisted_113 = { class: "block__field" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Негабарит", -1))
const _hoisted_115 = { class: "field__value" }
const _hoisted_116 = { class: "block__field" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Гос. номер прицепа", -1))
const _hoisted_118 = { class: "field__value" }
const _hoisted_119 = {
  key: 3,
  class: "FtlEditContainer"
}
const _hoisted_120 = { class: "FtlEditContainer__block" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Дополнительные услуги", -1))
const _hoisted_122 = { class: "mt-5" }
const _hoisted_123 = { class: "flex items-center justify-between" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold" }, "Доп услуги при заборе", -1))
const _hoisted_125 = { class: "mt-1" }
const _hoisted_126 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_127 = { class: "flex items-center justify-between mb-3" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_129 = { class: "flex items-center" }
const _hoisted_130 = { class: "flex items-center" }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { class: "flex items-center justify-between" }
const _hoisted_133 = { class: "text-lg font-semibold" }
const _hoisted_134 = { class: "mt-1" }
const _hoisted_135 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_136 = { class: "flex items-center justify-between mb-3" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_138 = { class: "flex items-center" }
const _hoisted_139 = { class: "flex items-center" }
const _hoisted_140 = { class: "flex items-center justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_create_additional_service = _resolveComponent("ftl-create-additional-service")!
  const _component_enter_carrier_data_intracity = _resolveComponent("enter-carrier-data-intracity")!
  const _component_ftl_on_the_way = _resolveComponent("ftl-on-the-way")!
  const _component_enter_delivered_data_intracity = _resolveComponent("enter-delivered-data-intracity")!
  const _component_enter_completed_data_intracity = _resolveComponent("enter-completed-data-intracity")!
  const _component_upload_ftl_order_scan = _resolveComponent("upload-ftl-order-scan")!
  const _component_upload_ftl_stock_scan = _resolveComponent("upload-ftl-stock-scan")!
  const _component_ftl_order_state = _resolveComponent("ftl-order-state")!
  const _component_ftl_order_header = _resolveComponent("ftl-order-header")!
  const _component_ftl_intracity_edit_tabs = _resolveComponent("ftl-intracity-edit-tabs")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.ftlOrder && _ctx.additional_state.is_open)
      ? (_openBlock(), _createBlock(_component_ftl_create_additional_service, {
          key: 0,
          "is-loading": _ctx.state.is_loading,
          "order-id": _ctx.state.ftlOrder.id,
          "sender-services": _ctx.state.ftlOrder.additional_service,
          sender: _ctx.state.ftlOrder.sender,
          stock: _ctx.additional_state.stock,
          onCancel: _ctx.toggleAdditionalService,
          onSubmitted: _ctx.onSubmitServices
        }, null, 8, ["is-loading", "order-id", "sender-services", "sender", "stock", "onCancel", "onSubmitted"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_carrier)
      ? (_openBlock(), _createBlock(_component_enter_carrier_data_intracity, {
          key: 1,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "shipment-type": _ctx.state.ftlOrder?.shipment_type_id,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          onSubmitted: _ctx.enterCarrierDataSubmit,
          onCancel: _ctx.toggleCarrier
        }, null, 8, ["ftl-type", "shipment-type", "is-need-car", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_on_the_way)
      ? (_openBlock(), _createBlock(_component_ftl_on_the_way, {
          key: 2,
          "is-loading": _ctx.state.is_on_the_way_loading,
          "order-id": _ctx.$route.params.order_id,
          onSubmit: _ctx.onTheWaySubmit,
          onCancel: _ctx.onTheWayCancel
        }, null, 8, ["is-loading", "order-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_delivered_intracity)
      ? (_openBlock(), _createBlock(_component_enter_delivered_data_intracity, {
          key: 3,
          "is-loading": _ctx.state.is_delivered_intracity_loading,
          "sender-city": _ctx.state.ftlOrder?.sender?.city,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "status-code": _ctx.state.ftlOrder?.status_code,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          onSubmitted: _ctx.onDeliveredIntracitySubmit,
          onCancel: _ctx.onDelieveredIntracityCancel
        }, null, 8, ["is-loading", "sender-city", "ftl-type", "status-code", "is-need-car", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_complete_intracity)
      ? (_openBlock(), _createBlock(_component_enter_completed_data_intracity, {
          key: 4,
          "is-loading": _ctx.state.is_complete_intracity_loading,
          "ftl-order": _ctx.state.ftlOrder,
          "additional-services": _ctx.state.ftlOrder?.additional_service,
          "sender-address": _ctx.state.ftlOrder?.sender?.full_address,
          stocks: _ctx.state.ftlOrder?.stock_delivery_notes,
          "status-code": _ctx.state.ftlOrder?.status_code,
          downtime: _ctx.state.ftlOrder?.downtime,
          "payment-rate-type-id": _ctx.state.ftlOrder?.downtime?.type,
          onSubmitted: _ctx.onCompleteIntracitySubmit,
          onCancel: _ctx.onCompleteIntracityCancel
        }, null, 8, ["is-loading", "ftl-order", "additional-services", "sender-address", "stocks", "status-code", "downtime", "payment-rate-type-id", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_scan_upload)
      ? (_openBlock(), _createBlock(_component_upload_ftl_order_scan, {
          key: 5,
          "ftl-order-id": _ctx.$route.params.order_id,
          "invoice-number": _ctx.state.ftlOrder.invoice_number,
          onSubmitted: _ctx.onScanUploadSubmit,
          onCancel: _ctx.onScanUploadCancel
        }, null, 8, ["ftl-order-id", "invoice-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.upload_ftl_stock_scan.is_opened)
      ? (_openBlock(), _createBlock(_component_upload_ftl_stock_scan, {
          key: 6,
          "ftl-stock-id": _ctx.upload_ftl_stock_scan.ftl_stock_id,
          "direction-name": _ctx.upload_ftl_stock_scan.ftl_stock_directionName,
          "stock-number": _ctx.upload_ftl_stock_scan.ftl_stock_number,
          onSubmitted: _ctx.uploadStockScanSubmit,
          onCancel: _ctx.uploadStockScanCancel
        }, null, 8, ["ftl-stock-id", "direction-name", "stock-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_ftl_order_state, {
          key: 7,
          "is-loading": _ctx.state.is_loading,
          "is-failed": _ctx.state.is_failed,
          onRetry: _ctx.loadFtlOrder
        }, null, 8, ["is-loading", "is-failed", "onRetry"]))
      : (_ctx.state.ftlOrder)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
            _createVNode(_component_ftl_order_header, {
              "order-status": _ctx.state.ftlOrder.status,
              "order-status-code": _ctx.state.ftlOrder.status_code,
              "is-billing-enabled": _ctx.state.ftlOrder.billing_enabled,
              "is-international-transportation": _ctx.state.ftlOrder.ftl_type === 1,
              "ftl-bid-id": _ctx.state.ftlOrder.ftl_bid_id,
              "payment-by-suppliers-id": _ctx.state.ftlOrder.payment_by_suppliers_id,
              scan: _ctx.state.ftlOrder.scan,
              "carrier-id": _ctx.state.ftlOrder.carrier_id,
              "is-need-car": _ctx.state.ftlOrder.is_need_car,
              "is-status-loading": _ctx.state.is_status_loading,
              "is-transcript-printing": _ctx.state.is_transcript_printing,
              "is-route-printing": _ctx.state.is_route_printing,
              "is-resending-to-one-c": _ctx.state.is_resending_to_one_c,
              "is-invoices-printing": _ctx.state.is_invoices_printing,
              "is-carrier-loading": _ctx.state.is_carrier_loading,
              "already-have-one-c": _ctx.state.is_already_have_one_c,
              "is-complete-loading": _ctx.state.is_complete_intracity_loading,
              "is-intracity": _ctx.state.ftlOrder.ftl_type === 2,
              "is-edit": "",
              onAssignStatusOnTheWay: _ctx.assignStatusOnTheWayHandler,
              onCarrier: _ctx.toggleCarrier,
              onDelivered: _ctx.toggleDelivered,
              onPrintTranscript: _ctx.onPrintTranscript,
              onPrintRoute: _ctx.onPrintRoute,
              onAssignStatusCanceled: _ctx.assignStatusCanceled,
              onPrintInvoices: _ctx.onPrintInvoices,
              onDownloadScan: _ctx.onDownloadScan,
              onUploadScan: _ctx.onScanUploadHandler,
              onCompleteIntracity: _ctx.toggleCompleteIntracity
            }, null, 8, ["order-status", "order-status-code", "is-billing-enabled", "is-international-transportation", "ftl-bid-id", "payment-by-suppliers-id", "scan", "carrier-id", "is-need-car", "is-status-loading", "is-transcript-printing", "is-route-printing", "is-resending-to-one-c", "is-invoices-printing", "is-carrier-loading", "already-have-one-c", "is-complete-loading", "is-intracity", "onAssignStatusOnTheWay", "onCarrier", "onDelivered", "onPrintTranscript", "onPrintRoute", "onAssignStatusCanceled", "onPrintInvoices", "onDownloadScan", "onUploadScan", "onCompleteIntracity"]),
            _createVNode(_component_ftl_intracity_edit_tabs, {
              value: _ctx.state.currentTab,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.currentTab) = $event)),
              "is-need-car": _ctx.state.ftlOrder.is_need_car
            }, null, 8, ["value", "is-need-car"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.state.currentTab === 'general')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_the_input, {
                                placeholder: "Дата забора",
                                value: _ctx.state_edit.take_date,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state_edit.take_date) = $event)),
                                type: "date",
                                "is-invalid": !_ctx.state_edit.take_date
                              }, null, 8, ["value", "is-invalid"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_the_input, {
                                placeholder: "Время забора",
                                value: _ctx.state_edit.take_time,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state_edit.take_time) = $event)),
                                type: "time",
                                "is-invalid": !_ctx.state_edit.take_time
                              }, null, 8, ["value", "is-invalid"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_the_input, {
                                placeholder: "Номер АВР Spark",
                                value: _ctx.state_edit.act_number,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state_edit.act_number) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_the_input, {
                                placeholder: "Дата АВР",
                                type: "datetime-local",
                                value: _ctx.state_edit.act_created_at,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state_edit.act_created_at) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_the_input, {
                                placeholder: "Отработанные часы для выставления",
                                value: _ctx.state_edit.auto_duration,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state_edit.auto_duration) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_the_input, {
                                placeholder: "Количество авто",
                                value: _ctx.state_edit.auto_count,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state_edit.auto_count) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_the_input, {
                                placeholder: "Номер накладной заказчика",
                                value: _ctx.state_edit.dop_order_number,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state_edit.dop_order_number) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_the_input, {
                                placeholder: "Адрес отправителя",
                                value: _ctx.state_edit.sender.fullAddress,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state_edit.sender.fullAddress) = $event))
                              }, null, 8, ["value"])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'payment')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_the_input, {
                                placeholder: "Объявленная стоимость",
                                value: _ctx.state_edit.declared_price,
                                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state_edit.declared_price) = $event)),
                                maska: _ctx.PRICE_MASK
                              }, null, 8, ["value", "maska"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_the_select, {
                                placeholder: "Кем будет производиться оплата",
                                options: _ctx.PAYMENT_TYPE_OPTIONS,
                                value: _ctx.state_edit.payment_type,
                                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state_edit.payment_type) = $event))
                              }, null, 8, ["options", "value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_the_select, {
                                placeholder: "Предоплата",
                                options: _ctx.PRE_PAID_OPTIONS,
                                value: _ctx.state_edit.is_pre_paid,
                                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state_edit.is_pre_paid) = $event))
                              }, null, 8, ["options", "value"])
                            ])
                          ]),
                          (
                                        _ctx.havePermissions(['all-root-permission']) &&
                                        _ctx.state.is_downtime
                                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_radio_group, {
                                      name: "shipment_type",
                                      value: _ctx.state_edit.downtime.type,
                                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state_edit.downtime.type) = $event)),
                                      options: _ctx.FTL_ORDER_PAYMENT_RATE_TYPES,
                                      class: "small"
                                    }, null, 8, ["value", "options"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("div", _hoisted_51, [
                                    _createVNode(_component_the_input, {
                                      placeholder: "Кол-во часов простоя для себестоимости",
                                      value: _ctx.state_edit.downtime.hours,
                                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state_edit.downtime.hours) = $event))
                                    }, null, 8, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _hoisted_53,
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_the_input, {
                                      placeholder: "Кол-во часов простоя для выставления",
                                      value: _ctx.state_edit.downtime.hours_for_client,
                                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state_edit.downtime.hours_for_client) = $event))
                                    }, null, 8, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.getPlaceholder('Себестоимость за простой')), 1),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createVNode(_component_the_input, {
                                      placeholder: 
                                                    _ctx.getPlaceholder('Себестоимость за простой')
                                                ,
                                      value: _ctx.state_edit.downtime.cost_price,
                                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state_edit.downtime.cost_price) = $event))
                                    }, null, 8, ["placeholder", "value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _hoisted_59,
                                  _createElementVNode("div", _hoisted_60, [
                                    _createVNode(_component_the_input, {
                                      placeholder: "Выставление за простой",
                                      value: _ctx.state_edit.downtime.paid_price,
                                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state_edit.downtime.paid_price) = $event))
                                    }, null, 8, ["value"])
                                  ])
                                ])
                              ]))
                            : (_ctx.havePermissions(['all-root-permission']))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createVNode(_component_the_button, {
                                    class: "primary small",
                                    onClick: _ctx.toggleDowntime
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Добавить простой ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.state.ftlOrder.is_need_car)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, " Себестоимость за перевозку (" + _toDisplayString(_ctx.getVatText) + ") за рейс ", 1),
                                _createElementVNode("div", _hoisted_67, [
                                  _createVNode(_component_the_input, {
                                    placeholder: `Себестоимость за перевозку (${_ctx.getVatText}) за рейс`,
                                    value: _ctx.state_edit.cost_price_per_hour,
                                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state_edit.cost_price_per_hour) = $event)),
                                    type: "number",
                                    step: "any"
                                  }, null, 8, ["placeholder", "value"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("div", _hoisted_70, [
                                  _createVNode(_component_the_input, {
                                    placeholder: "Общая себестоимость за перевозку",
                                    value: _ctx.state_edit.cost_price,
                                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state_edit.cost_price) = $event))
                                  }, null, 8, ["value"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.ftlOrder.is_need_car)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _hoisted_72,
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createElementVNode("div", _hoisted_76, [
                                  _createVNode(_component_the_input, {
                                    placeholder: "Выставление клиенту за перевозку за рейс",
                                    value: _ctx.state_edit.paid_price_per_hour,
                                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state_edit.paid_price_per_hour) = $event))
                                  }, null, 8, ["value"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("div", _hoisted_79, [
                                  _createVNode(_component_the_input, {
                                    placeholder: "Выставление клиенту за перевозку",
                                    value: _ctx.state_edit.paid_price,
                                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state_edit.paid_price) = $event))
                                  }, null, 8, ["value"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'vehicle-information')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_component_the_select, {
                                value: _ctx.state_edit.carrier_id,
                                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state_edit.carrier_id) = $event)),
                                placeholder: "Компания перевозчик",
                                options: _ctx.data_state.carriers.list,
                                loading: _ctx.data_state.carriers.is_loading,
                                failed: _ctx.data_state.carriers.is_failed,
                                "infinite-scroll": "",
                                onRefresh: _cache[22] || (_cache[22] = ($event: any) => (
                                                _ctx.loadCarriers(
                                                    _ctx.data_state.carriers.pagination.current_page
                                                )
                                            )),
                                onLoadmore: _cache[23] || (_cache[23] = ($event: any) => (
                                                _ctx.loadMoreCarriers(
                                                    _ctx.data_state.carriers.pagination.current_page + 1
                                                )
                                            )),
                                onSearch: _ctx.searchCarriers,
                                onOptionBySearch: _ctx.unshiftFindedCarrier
                              }, {
                                "selected-option": _withCtx(({ option }) => [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                    _createVNode(_component_cheap, {
                                      class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ])
                                ]),
                                option: _withCtx(({ option }) => [
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                    _createVNode(_component_cheap, {
                                      class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _hoisted_90,
                            _createElementVNode("div", _hoisted_91, [
                              _createVNode(_component_the_select, {
                                placeholder: "Автомобиль",
                                loading: _ctx.data_state.cars.is_loading,
                                failed: _ctx.data_state.cars.is_failed,
                                "error-text": "При получении списка автомобилей произошла ошибка",
                                options: _ctx.data_state.cars.list,
                                value: _ctx.state_edit.car.id,
                                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state_edit.car.id) = $event)),
                                "search-without-refresh": "",
                                "infinite-scroll": "",
                                onRefresh: _ctx.loadCars,
                                onLoadmore: _cache[25] || (_cache[25] = ($event: any) => (
                                                _ctx.loadMoreCars(
                                                    _ctx.data_state.cars.pagination.current_page + 1
                                                )
                                            )),
                                onSearch: _ctx.searchCars,
                                onOptionBySearch: _ctx.unshiftFindedCar,
                                onChange: _ctx.onCarSelect
                              }, {
                                "selected-option": _withCtx(({ option }) => [
                                  _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                                ]),
                                option: _withCtx(({ option }) => [
                                  _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                                ]),
                                _: 1
                              }, 8, ["loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _hoisted_93,
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_the_input, {
                                placeholder: "Марка авто",
                                value: _ctx.state_edit.car.brand,
                                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state_edit.car.brand) = $event)),
                                disabled: Boolean(_ctx.state_edit.car.id)
                              }, null, 8, ["value", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _hoisted_96,
                            _createElementVNode("div", _hoisted_97, [
                              _createVNode(_component_the_input, {
                                placeholder: "Кубатура",
                                value: _ctx.state_edit.car_info.cubature,
                                "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state_edit.car_info.cubature) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _hoisted_99,
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_component_the_select, {
                                value: _ctx.state_edit.car_info.loading_type,
                                "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state_edit.car_info.loading_type) = $event)),
                                options: _ctx.LOADING_TYPE_OPTIONS,
                                searchable: false,
                                selectBy: "name",
                                placeholder: "Тип погрузки"
                              }, null, 8, ["value", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _hoisted_102,
                            _createElementVNode("div", _hoisted_103, [
                              _createVNode(_component_the_input, {
                                placeholder: "Температурный режим",
                                value: _ctx.state_edit.car_info.temperature_regime,
                                "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state_edit.car_info.temperature_regime) = $event))
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _hoisted_105,
                            _createElementVNode("div", _hoisted_106, [
                              _createVNode(_component_the_input, {
                                placeholder: "Гос. номер",
                                value: _ctx.state_edit.car.number,
                                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state_edit.car.number) = $event)),
                                disabled: Boolean(_ctx.state_edit.car.id)
                              }, null, 8, ["value", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_107, [
                            _hoisted_108,
                            _createElementVNode("div", _hoisted_109, [
                              _createVNode(_component_the_select, {
                                value: _ctx.state_edit.driver.id,
                                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state_edit.driver.id) = $event)),
                                placeholder: "Имя водителя",
                                label: "fullName",
                                "search-by": "fullName",
                                "select-by": "id",
                                options: _ctx.data_state.couriers.list,
                                loading: _ctx.data_state.couriers.is_loading,
                                failed: _ctx.data_state.couriers.is_failed,
                                "error-text": "При получении списка водителей произошла ошибка",
                                "infinite-scroll": "",
                                onRefresh: _cache[32] || (_cache[32] = ($event: any) => (
                                                _ctx.loadCouriers(
                                                    _ctx.data_state.couriers.pagination.current_page
                                                )
                                            )),
                                onLoadmore: _cache[33] || (_cache[33] = ($event: any) => (
                                                _ctx.loadMoreCouriers(
                                                    _ctx.data_state.couriers.pagination.current_page + 1
                                                )
                                            )),
                                onSearch: _ctx.searchCouriers,
                                onOptionBySearch: _ctx.unshiftFindedCourier,
                                onChange: _ctx.onCourierSelect,
                                disabled: !_ctx.state_edit.carrier_id
                              }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch", "onChange", "disabled"]),
                              _createVNode(_component_the_input, {
                                placeholder: "Номер водителя",
                                value: _ctx.state_edit.driver.phone,
                                "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state_edit.driver.phone) = $event)),
                                disabled: Boolean(_ctx.state_edit.driver.id)
                              }, null, 8, ["value", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            _hoisted_111,
                            _createElementVNode("div", _hoisted_112, [
                              _createVNode(_component_the_select, {
                                value: _ctx.state_edit.car_info.load_capacity,
                                "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state_edit.car_info.load_capacity) = $event)),
                                options: _ctx.data_state.capacity_state.list,
                                loading: _ctx.data_state.capacity_state.is_loading,
                                searchable: false,
                                label: "load_capacity",
                                selectBy: "load_capacity",
                                placeholder: "Грузоподъёмность",
                                onChange: _ctx.onCapacityChange
                              }, null, 8, ["value", "options", "loading", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _hoisted_114,
                            _createElementVNode("div", _hoisted_115, [
                              _createVNode(_component_the_select, {
                                placeholder: "Негабарит",
                                options: _ctx.SPECIAL_CONDITIONS_OPTIONS,
                                value: _ctx.state_edit.special_conditions,
                                "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state_edit.special_conditions) = $event))
                              }, null, 8, ["options", "value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _hoisted_117,
                            _createElementVNode("div", _hoisted_118, [
                              _createVNode(_component_the_input, {
                                placeholder: "Гос. номер прицепа",
                                value: _ctx.state_edit.trailer_license_number,
                                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state_edit.trailer_license_number) = $event))
                              }, null, 8, ["value"])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.currentTab === 'additional-services')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _hoisted_121,
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", _hoisted_123, [
                            _hoisted_124,
                            _createVNode(_component_the_button, {
                              class: "primary small",
                              disabled: !_ctx.isCanAddService,
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.toggleAdditionalService()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Добавить доп услугу ")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _createElementVNode("p", _hoisted_125, " Адрес: " + _toDisplayString(_ctx.state.ftlOrder.sender && _ctx.state.ftlOrder.sender.full_address
                                            ? _ctx.state.ftlOrder.sender.full_address
                                            : '-'), 1),
                          _createElementVNode("div", _hoisted_126, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state_edit.additional_service, (additional_service, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `FormStateAdditionalService-${i}`,
                                class: "mt-2"
                              }, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createElementVNode("span", null, _toDisplayString(additional_service.type_name), 1),
                                  (
                                                    _ctx.havePermissions([
                                                        'additional-service-value-delete',
                                                        'all-root-permission',
                                                    ])
                                                )
                                    ? (_openBlock(), _createBlock(_component_the_button, {
                                        key: 0,
                                        class: "red small",
                                        loading: 
                                                    _ctx.delete_additional_service_state.is_loading
                                                ,
                                        hint: "Удалить",
                                        onClick: ($event: any) => (
                                                    _ctx.deleteAdditionalService(
                                                        i,
                                                        additional_service.id
                                                    )
                                                )
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_128
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_the_input, {
                                  placeholder: "Количество",
                                  value: additional_service.value,
                                  "onUpdate:value": ($event: any) => ((additional_service.value) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_the_input, {
                                  class: "mt-2",
                                  placeholder: "Продолжительность (клиенту)",
                                  value: additional_service.duration_client,
                                  "onUpdate:value": ($event: any) => ((additional_service.duration_client) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_the_input, {
                                  class: "mt-2",
                                  placeholder: "Продолжительность (себестоимость)",
                                  value: additional_service.duration,
                                  "onUpdate:value": ($event: any) => ((additional_service.duration) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_the_input, {
                                  class: "mt-2",
                                  placeholder: "Себестоимость за час",
                                  value: additional_service.cost_per_hour,
                                  "onUpdate:value": ($event: any) => ((additional_service.cost_per_hour) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_the_input, {
                                  class: "mt-2",
                                  placeholder: "Выставление клиенту за час",
                                  value: additional_service.paid_price_per_hour,
                                  "onUpdate:value": ($event: any) => ((additional_service.paid_price_per_hour) = $event),
                                  disabled: _ctx.isCompleted
                                }, null, 8, ["value", "onUpdate:value", "disabled"]),
                                (_ctx.state.ftlOrder.status_code === 'completed')
                                  ? (_openBlock(), _createBlock(_component_the_input, {
                                      key: 0,
                                      class: "mt-2",
                                      placeholder: "Общая себестоимость",
                                      value: additional_service.cost_total,
                                      "onUpdate:value": ($event: any) => ((additional_service.cost_total) = $event)
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : (_openBlock(), _createBlock(_component_the_input, {
                                      key: 1,
                                      class: "mt-2",
                                      placeholder: "Общая себестоимость",
                                      value: _ctx.getCostTotal(additional_service),
                                      disabled: ""
                                    }, null, 8, ["value"])),
                                (_ctx.state.ftlOrder.status_code === 'completed')
                                  ? (_openBlock(), _createBlock(_component_the_input, {
                                      key: 2,
                                      class: "mt-2",
                                      placeholder: "Выставление клиенту",
                                      value: additional_service.paid_price_total,
                                      "onUpdate:value": ($event: any) => ((additional_service.paid_price_total) = $event)
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : (_openBlock(), _createBlock(_component_the_input, {
                                      key: 3,
                                      class: "mt-2",
                                      placeholder: "Выставление клиенту",
                                      value: _ctx.getPaidPriceTotal(additional_service),
                                      disabled: ""
                                    }, null, 8, ["value"])),
                                _createVNode(_component_the_select, {
                                  class: "mt-2",
                                  value: additional_service.carrier_id,
                                  "onUpdate:value": [($event: any) => ((additional_service.carrier_id) = $event), 
                                                (newValue) =>
                                                    _ctx.onCarrierChange(newValue, additional_service)
                                            ],
                                  placeholder: "Выберите перевозчика",
                                  label: "name",
                                  "search-by": "name",
                                  "select-by": "id",
                                  options: _ctx.data_state.carriers.list,
                                  loading: _ctx.data_state.carriers.is_loading,
                                  failed: _ctx.data_state.carriers.is_failed,
                                  "error-text": "При получении списка перевозчиков произошла ошибка",
                                  "infinite-scroll": "",
                                  onRefresh: _cache[39] || (_cache[39] = ($event: any) => (
                                                _ctx.loadCarriers(
                                                    _ctx.data_state.carriers.pagination.current_page
                                                )
                                            )),
                                  onLoadmore: _cache[40] || (_cache[40] = ($event: any) => (
                                                _ctx.loadMoreCarriers(
                                                    _ctx.data_state.carriers.pagination.current_page + 1
                                                )
                                            ))
                                }, {
                                  "selected-option": _withCtx(({ option }) => [
                                    _createElementVNode("div", _hoisted_129, [
                                      _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                      _createVNode(_component_cheap, {
                                        class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ])
                                  ]),
                                  option: _withCtx(({ option }) => [
                                    _createElementVNode("div", _hoisted_130, [
                                      _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                      _createVNode(_component_cheap, {
                                        class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value", "options", "loading", "failed"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        (
                                    Boolean(
                                        _ctx.state_edit.stock_delivery_notes &&
                                            _ctx.state_edit.stock_delivery_notes.length
                                    )
                                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state_edit.stock_delivery_notes, (stock, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `stock-${idx}`,
                                  class: "mt-5"
                                }, [
                                  _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("h2", _hoisted_133, _toDisplayString(stock.directionName), 1),
                                    _createVNode(_component_the_button, {
                                      class: "primary small",
                                      disabled: !_ctx.isCanAddService,
                                      onClick: ($event: any) => (_ctx.toggleAdditionalService(stock))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Добавить доп услугу ")
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"])
                                  ]),
                                  _createElementVNode("p", _hoisted_134, " Адрес: " + _toDisplayString(stock.receiver ? stock.receiver.address : '-'), 1),
                                  _createElementVNode("div", _hoisted_135, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stock.additional_service, (additional_service, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `FormStateAdditionalService-${i}`,
                                        class: "mt-2"
                                      }, [
                                        _createElementVNode("div", _hoisted_136, [
                                          _createElementVNode("span", null, _toDisplayString(additional_service.type_name), 1),
                                          (
                                                        _ctx.havePermissions([
                                                            'additional-service-value-delete',
                                                            'all-root-permission',
                                                        ])
                                                    )
                                            ? (_openBlock(), _createBlock(_component_the_button, {
                                                key: 0,
                                                class: "red small",
                                                loading: 
                                                        _ctx.delete_additional_service_state.is_loading
                                                    ,
                                                hint: "Удалить",
                                                onClick: ($event: any) => (
                                                        _ctx.deleteAdditionalService(
                                                            i,
                                                            additional_service.id
                                                        )
                                                    )
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_137
                                                ]),
                                                _: 2
                                              }, 1032, ["loading", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createVNode(_component_the_input, {
                                          placeholder: "Количество",
                                          value: additional_service.value,
                                          "onUpdate:value": ($event: any) => ((additional_service.value) = $event)
                                        }, null, 8, ["value", "onUpdate:value"]),
                                        _createVNode(_component_the_input, {
                                          class: "mt-2",
                                          placeholder: "Продолжительность (клиенту)",
                                          value: additional_service.duration_client,
                                          "onUpdate:value": ($event: any) => ((additional_service.duration_client) = $event)
                                        }, null, 8, ["value", "onUpdate:value"]),
                                        _createVNode(_component_the_input, {
                                          class: "mt-2",
                                          placeholder: "Продолжительность (себестоимость)",
                                          value: additional_service.duration,
                                          "onUpdate:value": ($event: any) => ((additional_service.duration) = $event)
                                        }, null, 8, ["value", "onUpdate:value"]),
                                        _createVNode(_component_the_input, {
                                          class: "mt-2",
                                          placeholder: "Себестоимость за час",
                                          value: additional_service.cost_per_hour,
                                          "onUpdate:value": ($event: any) => ((additional_service.cost_per_hour) = $event)
                                        }, null, 8, ["value", "onUpdate:value"]),
                                        _createVNode(_component_the_input, {
                                          class: "mt-2",
                                          placeholder: "Выставление клиенту за час (с НДС)",
                                          value: 
                                                    additional_service.paid_price_per_hour
                                                ,
                                          "onUpdate:value": ($event: any) => ((
                                                    additional_service.paid_price_per_hour
                                                ) = $event),
                                          disabled: _ctx.isCompleted
                                        }, null, 8, ["value", "onUpdate:value", "disabled"]),
                                        (_ctx.state.ftlOrder.status_code === 'completed')
                                          ? (_openBlock(), _createBlock(_component_the_input, {
                                              key: 0,
                                              class: "mt-2",
                                              placeholder: "Общая себестоимость",
                                              value: additional_service.cost_total,
                                              "onUpdate:value": ($event: any) => ((additional_service.cost_total) = $event)
                                            }, null, 8, ["value", "onUpdate:value"]))
                                          : (_openBlock(), _createBlock(_component_the_input, {
                                              key: 1,
                                              class: "mt-2",
                                              placeholder: "Общая себестоимость",
                                              value: _ctx.getCostTotal(additional_service),
                                              disabled: ""
                                            }, null, 8, ["value"])),
                                        (_ctx.state.ftlOrder.status_code === 'completed')
                                          ? (_openBlock(), _createBlock(_component_the_input, {
                                              key: 2,
                                              class: "mt-2",
                                              placeholder: "Выставление клиенту",
                                              value: additional_service.paid_price_total,
                                              "onUpdate:value": ($event: any) => ((additional_service.paid_price_total) = $event)
                                            }, null, 8, ["value", "onUpdate:value"]))
                                          : (_openBlock(), _createBlock(_component_the_input, {
                                              key: 3,
                                              class: "mt-2",
                                              placeholder: "Выставление клиенту",
                                              value: _ctx.getPaidPriceTotal(additional_service),
                                              disabled: ""
                                            }, null, 8, ["value"])),
                                        _createVNode(_component_the_select, {
                                          class: "mt-2",
                                          value: additional_service.carrier_id,
                                          "onUpdate:value": [($event: any) => ((additional_service.carrier_id) = $event), 
                                                    (newValue) =>
                                                        _ctx.onCarrierChange(
                                                            newValue,
                                                            additional_service
                                                        )
                                                ],
                                          "is-invalid": !additional_service.carrier_id,
                                          placeholder: "Выберите перевозчика",
                                          label: "name",
                                          "search-by": "name",
                                          "select-by": "id",
                                          options: _ctx.data_state.carriers.list,
                                          loading: _ctx.data_state.carriers.is_loading,
                                          failed: _ctx.data_state.carriers.is_failed,
                                          "error-text": "При получении списка перевозчиков произошла ошибка",
                                          "infinite-scroll": "",
                                          onRefresh: _cache[41] || (_cache[41] = ($event: any) => (
                                                    _ctx.loadCarriers(
                                                        _ctx.data_state.carriers.pagination.current_page
                                                    )
                                                )),
                                          onLoadmore: _cache[42] || (_cache[42] = ($event: any) => (
                                                    _ctx.loadMoreCarriers(
                                                        _ctx.data_state.carriers.pagination
                                                            .current_page + 1
                                                    )
                                                ))
                                        }, {
                                          "selected-option": _withCtx(({ option }) => [
                                            _createElementVNode("div", _hoisted_138, [
                                              _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                              _createVNode(_component_cheap, {
                                                class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"])
                                            ])
                                          ]),
                                          option: _withCtx(({ option }) => [
                                            _createElementVNode("div", _hoisted_139, [
                                              _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                              _createVNode(_component_cheap, {
                                                class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value", "is-invalid", "options", "loading", "failed"])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_140, [
                  _createVNode(_component_the_button, {
                    class: "primary small",
                    disabled: _ctx.state.is_creating,
                    loading: _ctx.state.is_creating,
                    onClick: _ctx.saveOrder
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Сохранить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}